import { apiRequest } from '../../../../api-client';
import { type IntegrationConnection } from '../connections';

interface IntegrationConnectionRequest {
  enterpriseId: string;
  connectionId: string;
  token?: string;
  path?: string;
  method?: string;
  body?: unknown;
}

const integrationConnectionRequest = <T>({
  enterpriseId,
  connectionId,
  token,
  path,
  method,
  body
}: IntegrationConnectionRequest): Promise<T> => {
  return apiRequest<T>({
    endpoint: `/api/integrations/enterprises/${enterpriseId}/connections/${connectionId}${path}`,
    method,
    body,
    token
  });
};

export interface InitiateConnectionResponse {
  redirect_url: string;
}

export const initiateConnection = ({
  enterpriseId,
  token,
  connectionId
}: {
  enterpriseId: string;
  token: string;
  connectionId: string;
}) => {
  return integrationConnectionRequest<InitiateConnectionResponse>({
    path: '/initiate-connection',
    method: 'POST',
    enterpriseId,
    connectionId,
    token
  });
};

interface CompleteConnectionBody {
  oauth_token?: string;
  oauth_verifier?: string;
  oauth_code?: string;
}

/* Example of returned data
  [
    {
      "id": "d093f55f-8ea2-47e9-826f-d940a564ae80",
      "url": "https://dequesrc.atlassian.net",
      "name": "dequesrc",
      "scopes": [
        "read:jira-work",
        "manage:jira-webhook",
        "write:jira-work",
        "read:jira-user"
      ],
      "avatarUrl": "https://site-admin-avatar-cdn.prod.public.atl-paas.net/avatars/240/koala.png"
    }
  ]
  */
export interface JiraResource {
  id: string;
  url: string;
  name: string;
  scopes: string[];
  avatarUrl: string;
}
interface CompleteConnectionResponse {
  connection: IntegrationConnection;
  resources: JiraResource[];
}

export const completeConnection = ({
  enterpriseId,
  connectionId,
  token,
  body
}: {
  enterpriseId: string;
  connectionId: string;
  token?: string;
  body: CompleteConnectionBody;
}) => {
  return integrationConnectionRequest<CompleteConnectionResponse>({
    path: '/complete-connection',
    method: 'POST',
    enterpriseId,
    connectionId,
    token,
    body
  });
};

interface UpdateCompleteConnectionBody {
  cloud_id: string;
  base_url: string;
}

export const updateCompleteConnection = ({
  enterpriseId,
  connectionId,
  token,
  body
}: {
  enterpriseId: string;
  connectionId: string;
  token?: string;
  body: UpdateCompleteConnectionBody;
}) => {
  return integrationConnectionRequest<{ connection: IntegrationConnection }>({
    path: '/complete-connection',
    method: 'PUT',
    enterpriseId,
    connectionId,
    token,
    body
  });
};
